export default __webpack_public_path__ + "static/media/ENG. AGRO PEC.7a99be23.pdf";